var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 29,
    viewBox: "0 0 55 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.99999C0 2.68629 2.68629 0 6 0H48.7778C52.0915 0 54.7778 2.68629 54.7778 6V18.4211C54.7778 21.7348 52.0915 24.4211 48.7778 24.4211H36.2389C33.1735 24.4211 30.2563 25.7402 28.2317 28.0418C27.7847 28.55 26.993 28.55 26.546 28.0418C24.5214 25.7402 21.6043 24.4211 18.5389 24.4211H6.00001C2.6863 24.4211 0 21.7348 0 18.4211V5.99999Z",
    fill: "#111827"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartHover);
export default __webpack_public_path__ + "static/media/ChartHover.1a1798017a5a63114194f354c6018000.svg";
export { ForwardRef as ReactComponent };